export default __webpack_public_path__ + "static/media/image-earphones.1a9da441.png";